import { PlatformLocation } from '@angular/common';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { PerfectScrollbarConfigInterface, PerfectScrollbarComponent } from 'ngx-perfect-scrollbar';
import { TipoTag } from 'src/app/models/enum';
import { ResumoPedido } from 'src/app/models/resumoPedido';
import { TagGi } from 'src/app/models/tag-gi';
import { PedidoAnexoComponent } from 'src/app/pedido/pedido-anexo/pedido-anexo.component';
import { CarregandoService } from 'src/app/services/carregando.service';
import { FuncionarioService } from 'src/app/services/funcionario.service';
import { GlobalService } from 'src/app/services/global.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { PedidoService } from 'src/app/services/pedido.service';
import { RelatorioService } from 'src/app/services/relatorio.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';
import swal from 'sweetalert2';
import { AnexoModalComponent } from '../anexo-modal/anexo-modal.component';
import { NotaFiscalPedidoModalComponent } from '../nota-fiscal-pedido-modal/nota-fiscal-pedido-modal.component';
import { ObsModalComponent } from '../obs-modal/obs-modal.component';
import { ResumoModalComponent } from '../resumo-modal/resumo-modal.component';
import { SelecionarTagModalComponent } from '../selecionar-tag-modal/selecionar-tag-modal.component';

declare const $: any;

@Component({
  selector: 'app-observacoes-modal',
  templateUrl: './observacoes-modal.component.html',
  styleUrls: ['./observacoes-modal.component.scss']
})
export class ObservacoesModalComponent implements OnInit {
  public config: PerfectScrollbarConfigInterface = {};

  resumo: ResumoPedido = new ResumoPedido();
  somenteLeitura = false;
  texto = '';
  voltouProTopo = false;
  mensagemPrivada = false;

  imprimirResumo = false;

  ocultarValores = false;
  mostrarDescontoItens = false;

  integrador = false;

  subTotalItensBruto = 0;
  subTotalItensLiquido = 0;

  items: any[] = [];
  public htmlCode: string;
  public htmlDoc: HTMLElement;

  public mentionConfig = {
    labelKey: 'nome',
    dropUp: true,
    mentionSelect: (e: any) => {
      return '##' + e.nome + '##';
    },
  };
  selecionados: number[] = [];

  podeAdicionarNota: boolean = false;

  alterouTag = false;

  ocultarBotoes = false;

  @ViewChild('perfectScrollResumo', { static: false }) perfectScroll: PerfectScrollbarComponent;
  @ViewChild(PerfectScrollbarComponent, { static: false }) componentRef?: PerfectScrollbarComponent;

  constructor(public dialogRef: MatDialogRef<ObservacoesModalComponent>, private relatorioService: RelatorioService, private globalService: GlobalService,
    @Inject(MAT_DIALOG_DATA) public data: any, private pedidoService: PedidoService, private utilitarioService: UtilitarioService,
    private carregandoService: CarregandoService, private notificacaoService: NotificacaoService, private platformLocation: PlatformLocation,
    public dialog: MatDialog, private funcionarioService: FuncionarioService) {
    this.podeAdicionarNota = data.podeAdicionarNota;
    this.ocultarBotoes = data.ocultarBotoes;
  }

  ngAfterViewInit(): void {
    // this.perfectScroll.directiveRef.scrollToTop(0,100);
  }

  voltarProTopo() {
    if (!this.voltouProTopo) {
      this.perfectScroll.directiveRef.scrollToTop(0, 0);
      this.voltouProTopo = true;
    }
  }

  async ngOnInit() {
    this.integrador = await this.globalService.integrador();
    this.texto = this.integrador ? 'Orçamento' : 'Pedido';

    this.ocultarValores = this.data.ocultarValores;
    this.mostrarDescontoItens = this.data.mostrarDescontoItens;

    this.buscarResumo();
  }

  buscarVendedores() {
    this.carregandoService.mostra('buscarVendedores');

    this.funcionarioService.consultarFuncionarioPorIdCupom(this.resumo.idCupom).subscribe(dados => {
      this.items = dados.filter(d => d.podeVerMensagem);

      this.carregandoService.esconde('buscarVendedores');
    }, (erro) => {
      this.carregandoService.esconde('buscarVendedores');
      this.notificacaoService.erro(erro);
    });
  }

  buscarResumo() {
    this.carregandoService.mostra('buscarResumo');

    this.somenteLeitura = this.data.somenteLeitura;

    this.pedidoService.consultarResumo(this.data.idCupom).subscribe(
      (res) => {
        this.resumo = res;
        this.resumo.itens.forEach(p => {
          this.subTotalItensBruto += p.vTotalBruto;
          this.subTotalItensLiquido += p.vTotal;
        });
        this.buscarVendedores();
        if (this.componentRef && this.componentRef.directiveRef) {
          setTimeout(() => {
            this.componentRef.directiveRef.scrollToBottom();
          }, 10);

        }
        // window.scrollTo({ left: 0, top: document.body.scrollHeight, behavior: "smooth" });
        // $('html,body').animate({scrollTop: 9999});
        // $(window).scrollTop($('#foco').offset().top);
        this.carregandoService.esconde('buscarResumo');
      },
      (erro) => {
        this.carregandoService.esconde('buscarResumo');
        this.notificacaoService.erro(erro);
      }
    );
  }

  confirmarPedido(enviarAnexo) {

    const mensagem = 'Deseja realmente CONFIRMAR o Pedido?';
    swal({
      title: 'ATENÇÃO!',
      text: mensagem,
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false
    }).then((result) => {
      if (result.value) {

        if (enviarAnexo || !this.integrador) {
          const largura = Number(($('body').width()));

          const dialogRef = this.dialog.open(AnexoModalComponent, {
            width: largura > 730 ? '700px' : (($('body').width()).toString() + 'px'),
            data: { idCupom: this.resumo.idCupom },
            panelClass: 'modal-card'
          });

          dialogRef.afterClosed().subscribe((result) => {
            if (result) {
              this.confirmar(result);
            }
          });
        } else {
          this.confirmar(false);
        }
      }
    });
  }

  confirmar(arquivo) {
    this.carregandoService.mostra('confirmaPedido');

    this.pedidoService.confirmar(this.resumo.idCupom, 0,
      0, '', false, {}, true, false, arquivo, 0, [], [], this.resumo.dispEstoque, this.resumo.dataDispEstoque, null, null, null).subscribe((resp: any) => {
        this.carregandoService.esconde('confirmaPedido');
        this.notificacaoService.sucesso('Pedido Confirmado com sucesso!!!');
        this.dialogRef.close(true);
      }, (erro) => {
        this.carregandoService.esconde('confirmaPedido');
        this.notificacaoService.erro(erro);
      });
  }

  imprimirPedido() {
    this.carregandoService.mostra('imprimirPedido');

    this.relatorioService.pedido(this.resumo.idCupom).subscribe(resp => {

      this.notificacaoService.sucesso('Documento gerado com sucesso!!!');
      this.utilitarioService.openBlob(resp);

      this.carregandoService.esconde('imprimirPedido');
    }, (erro) => {
      const reader = new FileReader();

      // This fires after the blob has been read/loaded.
      reader.addEventListener('loadend', (e) => {
        const text = e.srcElement['result'];
        this.carregandoService.esconde('imprimirPedido');
        this.notificacaoService.erro(text);
      });

      // Start reading the blob as text.
      reader.readAsText(erro.error);
    });
  }

  imprimirResumoPedido() {
    this.carregandoService.mostra('imprimirResumoPedido');

    this.relatorioService.resumoDoPedido(99, this.resumo.idCupom, this.ocultarValores, this.mostrarDescontoItens).subscribe(resp => {

      this.notificacaoService.sucesso('Documento gerado com sucesso!!!');
      this.utilitarioService.openBlob(resp);

      this.carregandoService.esconde('imprimirResumoPedido');
    }, (erro) => {
      const reader = new FileReader();

      // This fires after the blob has been read/loaded.
      reader.addEventListener('loadend', (e) => {
        const text = e.srcElement['result'];
        this.carregandoService.esconde('imprimirResumoPedido');
        this.notificacaoService.erro(text);
      });

      // Start reading the blob as text.
      reader.readAsText(erro.error);
    });
  }

  novaObservacao() {
    const largura = Number(($('body').width()));

    const dialogRef = this.dialog.open(ObsModalComponent, {
      width: largura > 730 ? '700px' : (($('body').width()).toString() + 'px'),
      data: {
        tipo: 0,
        idCupom: this.resumo.idCupom
      },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.salvarObservacao(result);
      }
    });
  }

  salvarObservacao(observacao) {
    this.carregandoService.mostra('salvarObservacao');

    this.pedidoService.atualizarObservacao(this.resumo.idCupom, observacao, this.selecionados, this.mensagemPrivada).subscribe(
      (res) => {
        this.carregandoService.esconde('salvarObservacao');
        this.notificacaoService.sucesso('Mensagem enviada com sucesso!!!');
        this.buscarResumo();
        setTimeout(() => {
          this.htmlDoc = document.getElementById('my-content');
          this.htmlDoc.innerHTML = '';
        }, 10);
      },
      (erro) => {
        this.carregandoService.esconde('salvarObservacao');
        this.notificacaoService.erro(erro);
      }
    );
  }

  fechar() {
    this.dialogRef.close(this.alterouTag);
  }

  itemSelected(event: any) {
    this.selecionados.push(event.idFuncion);
    setTimeout(() => {
      this.htmlDoc = document.getElementById('my-content');
      this.htmlDoc.innerHTML = this.htmlDoc.innerHTML.replace(
        '##' + event.nome + '##',
        ' <b data-id=' + event.idFuncion + ' class="mention-user">@' + event.nome + '</b>&nbsp;'
      );
      // put the cursor to the end of field again...
      this.selectEnd();
    }, 10);
  }

  selectEnd() {
    let range, selection;
    range = document.createRange();
    range.selectNodeContents(this.htmlDoc);
    range.collapse(false);
    selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(range);
  }

  gerar() {
    setTimeout(() => {
      this.htmlDoc = document.getElementById('my-content');

      if (this.htmlDoc.innerHTML === '') return;
      // if (this.htmlDoc.value.toString() === '') return;

      this.selecionados = [...new Set(this.selecionados)];

      this.selecionados.forEach(element => {
        if (!this.htmlDoc.innerHTML.includes('data-id="' + element + '"')) {
          this.selecionados = this.selecionados.filter(function (item) {
            return item !== element;
          });
        }
      });

      const citadosIncorretamente = this.items.filter(p => this.htmlDoc.innerHTML.includes('@' + p.nome) && !this.htmlDoc.innerHTML.includes('data-id="' + p.idFuncion + '"'));

      if (citadosIncorretamente !== null && citadosIncorretamente !== undefined && citadosIncorretamente.length > 0) {
        swal({
          title: 'ATENÇÃO!!!',
          html: 'Existem usuários citados incorretamente:<br>' + citadosIncorretamente.map(p => p.nome).join('<br>'),
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-warning',
          type: 'warning'
        }).catch(swal.noop);
      } else {
        this.salvarObservacao(this.htmlDoc.innerHTML);
      }

    }, 10);
  }

  anexos(idCupom) {
    const largura = Number(($('body').width()));
    const dialogRef = this.dialog.open(PedidoAnexoComponent, {
      width: this.integrador && largura > 830 ? '800px' : (($('body').width()).toString() + 'px'),
      data: {
        idPedido: idCupom,
        podeEditar: true
      },
      panelClass: 'modal-card'
    });
  }

  notasFiscais(idCupom) {
    const largura = Number(($('body').width()));
    const dialogRef = this.dialog.open(NotaFiscalPedidoModalComponent, {
      width: largura > 830 ? '800px' : (($('body').width()).toString() + 'px'),
      data: {
        idCupom: idCupom,
        podeAdicionarNota: this.podeAdicionarNota
      },
      panelClass: 'modal-card'
    });
  }

  resumoDoPedido(idCupom) {
    const largura = Number(($('body').width()));

    const dialogRef = this.dialog.open(ResumoModalComponent, {
      width: (($('body').width()).toString() + 'px'),
      data: {
        idCupom: idCupom,
        somenteLeitura: true,
        ocultarValores: false,
        mostrarDescontoItens: true,
        exibirConcordarTermos: false,
        tipo: 10
      },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {

      }
    });
  }

  selecionarTag() {
    const largura = Number(($('body').width()));

    const dialogRef = this.dialog.open(SelecionarTagModalComponent, {
      width: largura > 850 ? '800px' : (($('body').width()).toString() + 'px'),
      data: { idCupom: this.resumo.idCupom, tags: this.resumo.tags.map(t => t.id), somenteIncluir: true, tipo: TipoTag.pedido },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.alterouTag = true;
        this.buscarResumo();
      }
    });
  }
}
